import Axios from 'axios'
import { getBaseURL } from './shared/utils/common'

Axios.defaults.baseURL = getBaseURL()
